export default {
  vgn: {
    name: 'Vegansk',
    emoji: '🌱',
  },
  vgt: {
    name: 'Vegetarisk',
    emoji: '🥬',
  },
  gf: {
    name: 'Glutenfri',
  },
  df: {
    name: 'Mælkefri',
  },
  hal: {
    name: 'Halal',
  },
  'h&s': {
    name: 'Stærk',
    emoji: '🌶',
  },
};
